//Models
PJQ.models.dailyReports.WorkLog = PJQ.models.BaseModel.extend({
	idAttribute: 'workLogId',
	notifyName: 'Work Log',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'dailyReports',
                value: this.get('dailyReportId')
            },
            {
                endpoint: 'workLogs',
                value: this.id
            }
        ]);
	},
	parse: function (model) {
		model = model ? model : {};

		if (model.workBy) {
			this.workBy = new PJQ.models.projectContacts.ProjectContact(model.workBy);
		}
		else{
			this.workBy = null;
		}

		this.groups = new PJQ.collections.groups.Groups(model.groups);

		this.workItems = new PJQ.collections.dailyReports.WorkLogWorkItems(model.workItems);

		this.attachments = new PJQ.collections.dailyReports.WorkLogAttachments(model.attachments);
		this.attachments.on('update', _.bind(function(){
			this.isDirty = true;
		}, this));

		return model;
	},
	beforeSave: function () {
		this.set('workBy', this.workBy);
		this.set('groups', this.groups.toJSON());
		this.set('workItems', this.workItems.toJSON());
		this.set('attachments', this.attachments.toJSON());
	}
});

PJQ.models.dailyReports.WorkLogWorkItem = PJQ.models.BaseModel.extend({
	idAttribute: 'id',
	notifyName: 'Work Item'
});

PJQ.models.dailyReports.WorkLogAttachment = PJQ.models.dailyReports.Attachment.extend({
	idAttribute: 'workLogAttachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'workLogs',
				value: this.get('workLogId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});


//Collections
PJQ.collections.dailyReports.WorkLogs = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.dailyReports.WorkLog
});

PJQ.collections.dailyReports.WorkLogWorkItems = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.WorkLogWorkItem
});

PJQ.collections.dailyReports.WorkLogAttachments = PJQ.collections.dailyReports.Attachments.extend({
	model: PJQ.models.dailyReports.WorkLogAttachment
});